import './AboutUs.css';

import React from 'react';
import data from '../../mocks/AboutUs.json';

function AboutUs() {
  return (
    <div className='main-container-about'>
      <div className='about-description'>
        <div className='description-detail'>
          {data.AboutDescriptionView.WhoWeAre.detail}
        </div>
        <div className='description-title'>
          <br />
          {data.AboutDescriptionView.WhyAreWeDifferent.title}
        </div>
        <div className='description-detail'>
          {data.AboutDescriptionView.WhyAreWeDifferent.detail}
        </div>
        <div className='description-title'>
          <br />
          {data.AboutDescriptionView.WhatWeOffer.title}
        </div>
        <div className='description-detail'>
          {data.AboutDescriptionView.WhatWeOffer.detail}
        </div>
        <button
          className='btn-contactUs'
          onClick={() => {
            window.location.href = 'mailto:info@eurointelligence.com';
          }}
        >
          Contact Us
        </button>
      </div>
      <div className='aboutContributors'>
        <div className='contributors-heading'>Contributors</div>
        <div className='contributors-details'>
          {data.AboutDescriptionView.contributors.map((contributor, index) => (
            <span key={`contributor-${index}`} className='spanContributors'>
              <div key={index} className='contributor'>
                <div className='contributor-image'>
                  <img
                    className='contributor-image-style'
                    src={contributor.image}
                    alt={contributor.name}
                  />
                </div>
                <div className='contributor-name'>{contributor.name}</div>
                <div className='description-about-us'>{contributor.detail}</div>
                {contributor.links &&
                  contributor.links.map((item, linkIndex) => (
                    <div
                      key={`link-${linkIndex}`}
                      className='description-about-us'
                    >
                      {item.title} <a href={item.url}>{item.url}</a>
                    </div>
                  ))}
              </div>
            </span>
          ))}
        </div>
      </div>
      <div className='tesms-and-condition-about-us-container'>
        <a href='/TermsOfUse'>Terms of use</a> and{' '}
        <a href='/PrivacyPolicy'>Privacy policy</a>
      </div>
    </div>
  );
}

export default AboutUs;
